import {
    connect,
} from 'react-redux';
import View from './OwnerDropdownView';
import {
    selectedLabel,
    selectedIndex,
    options,
} from './OwnerDropdownSelector';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedLabel: selectedLabel(state, ownProps),
        selectedIndex: selectedIndex(state, ownProps),
        options: options(ownProps),
        setSelectedIndex: ownProps.setSelectedIndex,
    };
};

export default connect(mapStateToProps)(View);
